export default __webpack_public_path__ + "static/media/forestly-noexpl-01_DE.cb3c4b65.png";